import {
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
} from '@mui/material';

import { labelStyles, radioStyles, rootStyles } from './styles';
import { RadioGroupProps } from './types';
import { ReactNode } from 'react';

export function RadioGroup<ItemID = string>({
  items,
  ...rest
}: RadioGroupProps<ItemID>) {
  return (
    <MuiRadioGroup sx={rootStyles} {...rest}>
      {items.map(
        ({
          id,
          props: {
            control = <Radio sx={radioStyles} />,
            label = id,
            ...props
          } = {},
        }) => (
          <FormControlLabel
            sx={labelStyles}
            {...props}
            control={control}
            checked={rest.value === id}
            key={id as string}
            label={label as ReactNode}
            value={id}
          />
        ),
      )}
    </MuiRadioGroup>
  );
}
